/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_JobInputs */

const en_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const de_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const fr_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const es_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const it_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const nl_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const pl_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const fi_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const da_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const sv_story_bank_label_job = /** @type {(inputs: Story_Bank_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

/**
* | output |
* | --- |
* | "Job" |
*
* @param {Story_Bank_Label_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_job = /** @type {((inputs?: Story_Bank_Label_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_job(inputs)
	if (locale === "fr") return fr_story_bank_label_job(inputs)
	if (locale === "es") return es_story_bank_label_job(inputs)
	if (locale === "it") return it_story_bank_label_job(inputs)
	if (locale === "nl") return nl_story_bank_label_job(inputs)
	if (locale === "pl") return pl_story_bank_label_job(inputs)
	if (locale === "fi") return fi_story_bank_label_job(inputs)
	if (locale === "da") return da_story_bank_label_job(inputs)
	if (locale === "sv") return sv_story_bank_label_job(inputs)
	return en_story_bank_label_job(inputs)
});